import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["BottomNav"] */ "/vercel/path0/src/components/bottom-nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DesktopEffects"] */ "/vercel/path0/src/components/desktop-effects.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path0/src/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navbar"] */ "/vercel/path0/src/components/navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SmoothScrollProvider"] */ "/vercel/path0/src/components/smooth-scroll.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FirebaseClientProvider"] */ "/vercel/path0/src/firebase/client-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/vercel/path0/src/hooks/use-language.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TelegramUserProvider"] */ "/vercel/path0/src/hooks/use-telegram-user.tsx");
